exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page {\r\n    margin-left: 0px;\r\n    min-height: 700px;\r\n}\r\n\r\n.page .page-main {\r\n    margin-left: 260px;\r\n}\r\n\r\n/deep/ .modal-open .select2-container {\r\n    z-index: 1701!important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/ticket/field/field.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/ticket/field/field.css
// module chunks = main